export function getBetaUtmParams() {
  const params = new URLSearchParams(window.location.search);
  return {
    utmSource: params.get("utm_source") || "",
    utmMedium: params.get("utm_medium") || "",
    utmCampaign: params.get("utm_campaign") || "",
    utmContent: params.get("utm_content") || "",
    referrer: typeof document !== "undefined" ? document.referrer || "" : ""
  };
}

export function resolveInitialBetaSource() {
  const params = new URLSearchParams(window.location.search);
  const campaign = (params.get("utm_campaign") || "").toLowerCase();
  const source = (params.get("utm_source") || "").toLowerCase();

  if (campaign === "brianna_beta") return "Brianna Beta Outreach";
  if (source === "facebook") return "Facebook";
  if (source === "linkedin") return "LinkedIn";
  if (source === "email") return "Email";
  if (source === "friend" || source === "referral") return "Friend Referral";
  return "";
}

export function trackBetaEvent(eventName, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", eventName, params);
  }
  if (typeof window !== "undefined" && typeof window.clarity === "function") {
    window.clarity("event", eventName);
  }
}
